// extracted by mini-css-extract-plugin
export default {"Breadcrumb":"Breadcrumb_Breadcrumb__lSPIn","title":"Breadcrumb_title__WSZiY","btnBox":"Breadcrumb_btnBox__IEADx","crumbBtn":"Breadcrumb_crumbBtn__z+C1R"};